(function () {
    const loadMoreBtn = document.querySelector('[data-js="authors-load-more"]');

    if (!loadMoreBtn) {
        return;
    }

    const hiddenCards = document.querySelectorAll('.author-card--hidden');

    if (!hiddenCards.length) {
        loadMoreBtn.closest('.authors-hub__more')?.remove();
        return;
    }

    loadMoreBtn.addEventListener('click', () => {
        const loadText = loadMoreBtn.dataset.load || 'Загружаем...';

        loadMoreBtn.classList.add('is-loading');
        loadMoreBtn.textContent = loadText;

        window.setTimeout(() => {
            hiddenCards.forEach((card) => {
                card.classList.add('is-visible');
            });

            loadMoreBtn.closest('.authors-hub__more')?.remove();
        }, 200);
    });
})();
